var portfolioList = {
	label: {
		caption: "Portfolioliste",
		name: "Portfolio",
		currency: "Währung",
		numberOfPositions: "Positionen",
		numberOfTransactions: "Transaktionen",
		actions: "Aktionen"
	},
	noPortfolios: {
		title: "Info",
		message: "Es wurde noch kein Portfolio erstellt. Bitte klicken Sie auf die Schaltfläche \"Portfolio hinzufügen\" und füllen Sie das Formular aus, um ein Portfolio zu erstellen."
	},
	error: {
		title: "Ein Fehler ist aufgetreten",
		portfolioLimitExceeded: "Portfoliolimit überschritten"
	},
	createPortfolioAction: "Portfolio hinzufügen",
	editPortfolioAction: "Portfolio bearbeiten",
	deletePortfolioAction: "Portfolio löschen",
	showActions: "Aktionen anzeigen"
};
var de = {
	portfolioList: portfolioList
};

export { de as default, portfolioList };
